(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_9ecb9c4"] && !Shopify.designMode) return;
  try {
    (function () {

  'use strict';


  /* =========================================================
     FIND SHOPIFY PRODUCT FORM
     ========================================================= */

  function findProductForm(configurator) {

    /*
     * 1. Check nearest product-form element.
     */
    var productFormElement =
      configurator.closest('product-form');

    if (productFormElement) {

      var nearestForm =
        productFormElement.querySelector(
          'form[action*="/cart/add"]'
        );

      if (nearestForm) {
        return nearestForm;
      }

    }


    /*
     * 2. Check current Shopify section.
     */
    var section =
      configurator.closest('.shopify-section');

    if (section) {

      var sectionForm =
        section.querySelector(
          'form[action*="/cart/add"]'
        );

      if (sectionForm) {
        return sectionForm;
      }

    }


    /*
     * 3. Check product information container.
     */
    var productInformation =
      configurator.closest(
        '[id*="ProductInfo"], [data-product-form]'
      );

    if (productInformation) {

      var informationForm =
        productInformation.querySelector(
          'form[action*="/cart/add"]'
        );

      if (informationForm) {
        return informationForm;
      }

    }


    /*
     * 4. Final page-wide fallback.
     */
    return document.querySelector(
      'form[action*="/cart/add"]'
    );

  }


  /* =========================================================
     INITIALIZE ALL CONFIGURATORS
     ========================================================= */

  function initBoxConfigurators() {

    var configurators =
      document.querySelectorAll(
        '[data-box-configurator]'
      );


    configurators.forEach(function (configurator) {

      /*
       * Prevent duplicate event listeners when
       * Shopify Theme Editor reloads a section.
       */
      if (
        configurator.dataset.initialized === 'true'
      ) {
        return;
      }

      configurator.dataset.initialized = 'true';


      /* -----------------------------------------------------
         ELEMENTS
         ----------------------------------------------------- */

      var quantityInput =
        configurator.querySelector(
          '[data-box-quantity]'
        );


      var totalElement =
        configurator.querySelector(
          '[data-total]'
        );


      var totalPriceElement =
        configurator.querySelector(
          '[data-total-price]'
        );


      var minusButton =
        configurator.querySelector(
          '[data-minus]'
        );


      var plusButton =
        configurator.querySelector(
          '[data-plus]'
        );


      /*
       * Make sure required UI exists.
       */
      if (
        !quantityInput ||
        !totalElement ||
        !minusButton ||
        !plusButton
      ) {

        console.warn(
          'Box quantity: Required configurator elements not found.'
        );

        return;

      }


      /* -----------------------------------------------------
         PRODUCT PACKAGING CONFIGURATION
         ----------------------------------------------------- */

      var packagingConfigured =
        configurator.dataset.packagingConfigured === 'true';

      var piecesPerBox =
        parseInt(
          configurator.dataset.piecesPerBox,
          10
        ) || 0;

      /*
       * Shopify product structure:
       * - Variant = Bulk / Sample
       * - Quantity = number of boxes
       * - pieces_per_box = pieces contained in each box
       */

      /*
       * Pieces per box comes from:
       * product.metafields.custom.pieces_per_box
       *
       * It is intentionally NOT a Theme Editor setting.
       */
      if (!packagingConfigured || piecesPerBox < 1) {

        configurator.classList.add('is-unconfigured');

        quantityInput.disabled = true;
        minusButton.disabled = true;
        plusButton.disabled = true;

        if (totalElement) {
          totalElement.textContent = '—';
        }

        if (totalPriceElement) {
          totalPriceElement.innerHTML =
            '<strong>Packaging not configured</strong>';
        }

        console.warn(
          'Box quantity: Product metafield custom.pieces_per_box is missing or invalid.'
        );

        return;

      }


      /* -----------------------------------------------------
         VARIANT PRICE MAP
         ----------------------------------------------------- */

      var variantPrices = {};

      try {
        variantPrices =
          JSON.parse(
            configurator.getAttribute('data-variant-prices') || '{}'
          );
      } catch (error) {
        console.warn(
          'Box quantity: Could not read variant prices.',
          error
        );
      }

      var variantPieces = {};

      try {
        variantPieces =
          JSON.parse(
            configurator.getAttribute('data-variant-pieces') || '{}'
          );
      } catch (error) {
        console.warn(
          'Box quantity: Could not read variant pieces.',
          error
        );
      }


      /* -----------------------------------------------------
         PRODUCT FORM
         ----------------------------------------------------- */

      var productForm =
        findProductForm(configurator);


      if (!productForm) {

        console.warn(
          'Box quantity: Shopify product form not found.'
        );

        return;

      }


      /* =====================================================
         GET NATIVE SHOPIFY QUANTITY INPUT
         ===================================================== */

      function getNativeQuantityInput() {

        var input =
          productForm.querySelector(
            'input[name="quantity"]'
          );


        /*
         * If Shopify already has a quantity input,
         * use it.
         */
        if (input) {
          return input;
        }


        /*
         * Otherwise create one.
         */
        input =
          document.createElement('input');

        input.type = 'hidden';
        input.name = 'quantity';
        input.value = '1';

        productForm.appendChild(input);


        return input;

      }


      /* =====================================================
         UPDATE NATIVE PRODUCT PRICE
         ===================================================== */

      function getCurrentVariantId() {

        var variantInput =
          productForm.querySelector(
            'input[name="id"], select[name="id"]'
          );

        if (!variantInput) {
          variantInput =
            document.querySelector(
              '.shopify-section input[name="id"], ' +
              '.shopify-section select[name="id"]'
            );
        }

        return variantInput
          ? String(variantInput.value || '')
          : '';
      }


      function getPiecesPerCurrentVariant() {

        var variantId =
          getCurrentVariantId();

        if (
          variantId &&
          Object.prototype.hasOwnProperty.call(
            variantPieces,
            variantId
          )
        ) {
          return Number(variantPieces[variantId]) || 0;
        }

        return piecesPerBox;
      }


      function getVariantUnitPrice() {

        var variantId =
          getCurrentVariantId();

        if (
          variantId &&
          Object.prototype.hasOwnProperty.call(
            variantPrices,
            variantId
          )
        ) {
          return Number(variantPrices[variantId]) || 0;
        }

        /*
         * Fallback: read the current Shopify price from the
         * product page when a theme uses a non-standard form.
         */
        var priceElement =
          document.querySelector(
            '.shopify-section .price-item--regular, ' +
            '.shopify-section .price-item--sale, ' +
            '.shopify-section .price'
          );

        if (!priceElement) {
          return 0;
        }

        var text =
          priceElement.textContent.replace(/[^0-9.,]/g, '');

        if (!text) {
          return 0;
        }

        /* Shopify stores prices in cents. */
        var numeric =
          parseFloat(text.replace(/,/g, ''));

        return isNaN(numeric)
          ? 0
          : Math.round(numeric * 100);
      }


      function getCurrencyPrefixAndDecimals() {

        var priceElement =
          document.querySelector(
            '.shopify-section .price-item--regular, ' +
            '.shopify-section .price-item--sale, ' +
            '.shopify-section .price'
          );

        var currentText =
          priceElement
            ? priceElement.textContent.trim()
            : '';

        var match =
          currentText.match(
            /^([^0-9]*)([0-9][0-9,]*(?:[.]\d+)?)(.*)$/
          );

        return {
          prefix: match ? match[1] : 'Rs. ',
          suffix: match ? match[3] : '',
          decimals: match && match[2].indexOf('.') >= 0
            ? match[2].split('.')[1].length
            : 2
        };
      }


      function formatMoney(cents) {

        var moneyFormat =
          window.Shopify &&
          (window.Shopify.money_format ||
           window.Shopify.money_with_currency_format);

        if (
          window.Shopify &&
          typeof window.Shopify.formatMoney === 'function' &&
          moneyFormat
        ) {
          return window.Shopify.formatMoney(
            cents,
            moneyFormat
          );
        }

        var info =
          getCurrencyPrefixAndDecimals();

        var amount =
          (Number(cents) / 100).toFixed(info.decimals);

        amount =
          amount.replace(
            /\B(?=(\d{3})+(?!\d))/g,
            ','
          );

        return info.prefix + amount + info.suffix;
      }


      function getNativePriceElements() {

        var section =
          configurator.closest('.shopify-section');

        var scope =
          section || document;

        /*
         * Pitch may use different price wrappers depending on
         * the product template. Include all common selectors.
         */
        var elements =
          scope.querySelectorAll(
            '.price-item--regular, ' +
            '.price-item--sale, ' +
            '.product__price, ' +
            '.product-price, ' +
            '[data-product-price]'
          );

        return Array.prototype.filter.call(
          elements,
          function (element) {
            return !element.closest(
              '[data-box-configurator]'
            );
          }
        );
      }


      function updateDisplayedPrice() {

        var boxes =
          parseInt(
            quantityInput.value,
            10
          ) || 1;

        var currentPiecesPerBox =
          getPiecesPerCurrentVariant();

        var boxPrice =
          getVariantUnitPrice();

        /*
         * The Shopify variant price is the price of ONE BOX.
         *
         * Example:
         * 648 pieces / box
         * Box price = ₹1,620
         *
         * Price per piece:
         * ₹1,620 ÷ 648 = ₹2.50
         *
         * Final calculation:
         * Boxes × Pieces per Box × Price per Piece
         *
         * 1 × 648 × ₹2.50 = ₹1,620
         * 2 × 648 × ₹2.50 = ₹3,240
         */

        if (!boxPrice || !currentPiecesPerBox) {

          if (totalPriceElement) {
            totalPriceElement.innerHTML =
              '<strong>Price unavailable</strong>';
          }

          return;
        }

        /*
         * Convert the Shopify box price into
         * a price-per-piece value.
         *
         * Shopify prices are stored in cents.
         */
        var pricePerPiece =
          boxPrice / currentPiecesPerBox;

        /*
         * Calculate the total physical pieces.
         */
        var totalPieces =
          boxes * currentPiecesPerBox;

        /*
         * Calculate the final price from:
         *
         * total pieces × price per piece
         */
        var totalPrice =
          totalPieces * pricePerPiece;

        /*
         * Round to the nearest cent to prevent
         * floating-point precision issues.
         */
        totalPrice =
          Math.round(totalPrice);

        var formatted =
          formatMoney(totalPrice);

        /*
         * Always show the calculated total inside
         * the configurator.
         */
        if (totalPriceElement) {
          totalPriceElement.innerHTML =
            'Total price: <strong>' +
            formatted +
            '</strong>';
        }

        /*
         * Also update the native product price
         * when the theme price elements are available.
         */
        var priceElements =
          getNativePriceElements();

        priceElements.forEach(
          function (element) {

            element.dataset.boxConfiguratorUnitPrice =
              String(pricePerPiece);

            element.dataset.boxConfiguratorTotalPrice =
              String(totalPrice);

            /*
             * Do not overwrite complex compare-at-price
             * markup. Update only simple price nodes.
             */
            if (
              element.children.length === 0 ||
              element.matches(
                '.price-item--regular, .price-item--sale'
              )
            ) {
              element.textContent = formatted;
            }

          }
        );
      }

      function updateQuantity() {

        /*
         * Variant-specific packaging:
         * Bulk  = product metafield value (for example 500)
         * Sample = 1 piece per box
         */
        piecesPerBox =
          getPiecesPerCurrentVariant();

        var boxes =
          parseInt(
            quantityInput.value,
            10
          );


        /*
         * Always keep minimum quantity at 1 box.
         */
        if (
          isNaN(boxes) ||
          boxes < 1
        ) {

          boxes = 1;

        }


        /*
         * Update visible box quantity.
         */
        quantityInput.value =
          boxes;


        /*
         * Calculate total physical pieces.
         *
         * Example:
         * 1 box × 100 = 100 pieces
         * 2 boxes × 100 = 200 pieces
         * 3 boxes × 100 = 300 pieces
         */
        var totalPieces =
          boxes * piecesPerBox;


        /*
         * Update visible total.
         */
        var piecesPerBoxDisplay =
          configurator.querySelector(
            '[data-pieces-per-box-display]'
          );

        if (piecesPerBoxDisplay) {
          piecesPerBoxDisplay.textContent =
            piecesPerBox;
        }

        totalElement.textContent =
          totalPieces;


        /*
         * Update native Shopify quantity.
         *
         * IMPORTANT:
         * Shopify cart quantity = number of BOXES.
         *
         * It does NOT become totalPieces.
         */
        var nativeQuantity =
          getNativeQuantityInput();


        nativeQuantity.value =
          boxes;


        /*
         * Tell Shopify/theme scripts
         * that quantity changed.
         */
        nativeQuantity.dispatchEvent(
          new Event(
            'input',
            {
              bubbles: true
            }
          )
        );


        nativeQuantity.dispatchEvent(
          new Event(
            'change',
            {
              bubbles: true
            }
          )
        );


        /*
         * Update the visible product price using:
         *
         * total pieces × price per piece
         *
         * where:
         * total pieces = boxes × pieces per box
         * price per piece = box price ÷ pieces per box
         */
        updateDisplayedPrice();

      }


      /* =====================================================
         SYNC EVERYTHING
         ===================================================== */

      function syncConfigurator() {

        updateQuantity();

      }


      /* =====================================================
         MINUS BUTTON
         ===================================================== */

      minusButton.addEventListener(
        'click',
        function (event) {

          event.preventDefault();
          event.stopPropagation();


          var currentValue =
            parseInt(
              quantityInput.value,
              10
            ) || 1;


          var newValue =
            Math.max(
              1,
              currentValue - 1
            );


          quantityInput.value =
            newValue;


          syncConfigurator();

        }
      );


      /* =====================================================
         PLUS BUTTON
         ===================================================== */

      plusButton.addEventListener(
        'click',
        function (event) {

          event.preventDefault();
          event.stopPropagation();


          var currentValue =
            parseInt(
              quantityInput.value,
              10
            ) || 1;


          var newValue =
            currentValue + 1;


          quantityInput.value =
            newValue;


          syncConfigurator();

        }
      );


      /* =====================================================
         MANUAL QUANTITY INPUT
         ===================================================== */

      quantityInput.addEventListener(
        'input',
        function () {

          updateQuantity();

        }
      );


      quantityInput.addEventListener(
        'change',
        function () {

          updateQuantity();

        }
      );


      /* =====================================================
         VARIANT CHANGE SUPPORT
         ===================================================== */

      function refreshAfterVariantChange() {

        /*
         * Shopify themes can update the variant input before
         * or after firing their variant-change event.
         */
        window.setTimeout(
          function () {
            updateDisplayedPrice();
            syncConfigurator();
          },
          0
        );

      }


      productForm.addEventListener(
        'change',
        function (event) {

          if (
            event.target &&
            event.target.name === 'id'
          ) {
            refreshAfterVariantChange();
          }

        }
      );


      document.addEventListener(
        'change',
        function (event) {

          if (
            event.target &&
            (event.target.name === 'id' ||
             event.target.matches('[name^="options["]'))
          ) {
            refreshAfterVariantChange();
          }

        }
      );


      document.addEventListener(
        'variant:change',
        function () {
          refreshAfterVariantChange();
        }
      );


      /*
       * Pitch can replace the price markup when a variant
       * changes. Watch the product information area and
       * re-apply the box multiplier after that replacement.
       */
      var productInformation =
        configurator.closest(
          '[id*="ProductInfo"], [data-product-form], .shopify-section'
        );

      if (productInformation) {

        var priceObserver =
          new MutationObserver(
            function () {

              if (
                configurator.dataset.updatingPrice === 'true'
              ) {
                return;
              }

              window.clearTimeout(
                configurator._priceTimer
              );

              configurator._priceTimer =
                window.setTimeout(
                  function () {

                    configurator.dataset.updatingPrice =
                      'true';

                    updateDisplayedPrice();

                    window.setTimeout(
                      function () {
                        configurator.dataset.updatingPrice =
                          'false';
                      },
                      0
                    );

                  },
                  30
                );

            }
          );

        priceObserver.observe(
          productInformation,
          {
            childList: true,
            subtree: true
          }
        );

      }


      /* =====================================================
         INITIAL STATE
         ===================================================== */

      syncConfigurator();

    });

  }


  /* =========================================================
     INITIAL PAGE LOAD
     ========================================================= */

  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initBoxConfigurators
    );

  } else {

    initBoxConfigurators();

  }


  /* =========================================================
     SHOPIFY THEME EDITOR
     ========================================================= */

  document.addEventListener(
    'shopify:section:load',
    function () {

      initBoxConfigurators();

    }
  );


  document.addEventListener(
    'shopify:section:reorder',
    function () {

      initBoxConfigurators();

    }
  );


  document.addEventListener(
    'shopify:block:select',
    function () {

      initBoxConfigurators();

    }
  );


})();
  } catch(e) { console.error(e); }
})();

})();
